import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({
    title,
    description,
    keywords,
    image,
    url,
    author = 'Serenityy Financial & Marketing',
}) => {
    return (
        <Helmet>
            {/* Basic Meta Tags */}
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="author" content={author} />

            {/* Open Graph Meta Tags */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content="website" />

            {/* Twitter Meta Tags */}
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            <meta name="twitter:card" content="summary_large_image" />

            {/* Favicon */}
            <link rel="icon" href="/favicon.ico" />

            <script type="application/ld+json">
                {`
                    {
                    "@context": "http://schema.org",
                    "@type": "Organization",
                    "name": "Serenityy",
                    "url": "https://www.serenityy.ae",
                    "logo": "https://www.serenityy.ae/logo.png",
                    "sameAs": [
                        "https://www.linkedin.com/company/serenityymarketingmanagement/posts/?feedView=all",
                        "https://www.instagram.com/serenityy_marketing_management/",
                        "https://wa.me/+971543065542"
                    ],
                    "contactPoint": {
                        "@type": "ContactPoint",
                        "telephone": "+971543065542",
                        "contactType": "Customer Service",
                        "areaServed": "AE",
                        "availableLanguage": "English"
                    },
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Dubai, UAE",
                        "addressLocality": "Dubai",
                        "addressCountry": "AE"
                    },
                    "description": "Serenityy is a dynamic commercial organization offering financial and marketing services."
                    }
                `}
            </script>


        </Helmet>
    );
};

export default SEO;
